"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAxiosWithCache = createAxiosWithCache;
var _axios = _interopRequireDefault(require("axios"));
var _axiosCacheInterceptor = require("axios-cache-interceptor");
/**
 * Creates Axios instance pre-configured with cache (using axios-cache-adapter).
 * @param options Configuration options object
 * @returns Pre-configured Axios instance with cache
 */
function createAxiosWithCache({
  key,
  maxAge
}) {
  const options = {
    ttl: maxAge * 60 * 1000
  };
  if (key) {
    options.generateKey = (0, _axiosCacheInterceptor.buildKeyGenerator)(key);
  }
  return (0, _axiosCacheInterceptor.setupCache)(_axios.default.create(), options);
}
